/*eslint-disable */
import { VueEditor } from "vue2-editor";
export default {
  name: 'pdf-notes',
  components: {
    VueEditor
  },
  props: ['pdfIDForNote'],
  data () {
    return {
      pdfNotesListState:true,
      pdfNotesAddState:false,
      pdfNotesInfoUpdateState:false,
      editorOptions: {
        placeholder: 'Description...',
        editorToolbar: ['bold','italic','link']
      },
      editorData:'',
      createNoteTitle:'',
      createNoteData:'',
      notesListOfPdf:null,
      notesListOfPdfResults:[],
      updateNoteTitle:'',
      updateNoteData:'',
      updateNoteId:''
    }
  },
  computed: {

  },
  mounted () {
    this.getNoteListOfPDFMethod()
  },
  methods: {
    getNoteListOfPDFMethod(){
      this.$store.dispatch('getNotesToPdfFun', {id:this.pdfIDForNote}).then((res) => {
        this.notesListOfPdf = res.data.data
        this.notesListOfPdfResults = this.notesListOfPdf.results
      })
    },
    addNotesStepMethod(){
      this.pdfNotesListState = false
      this.pdfNotesAddState = true
    },
    addNewNotesInfoMethod(){
      if(this.createNoteData.length > 0){
        let data = {
          pdf_paper:this.pdfIDForNote,
          title:this.createNoteTitle,
          data:this.createNoteData
        }
        this.$store.dispatch('createNewNotesForPdfFun', data).then((res) => {
          this.pdfNotesListState = true
          this.pdfNotesAddState = false
          this.createNoteTitle = ''
          this.createNoteData = ''
          this.getNoteListOfPDFMethod()
        }).catch((err) => {

        })
      }else{
        this.pdfNotesListState = true
        this.pdfNotesAddState = false
      }
    },
    updateNotesInfoMethod(){
      let data = {
        pdf_paper:this.pdfIDForNote,
        title:this.updateNoteTitle,
        data:this.updateNoteData
      }
      this.$store.dispatch('updateNotesInfoOfPdfFun', {data:{data:data,id:this.updateNoteId}}).then((res) => {
        this.pdfNotesInfoUpdateState = false
        this.pdfNotesListState = true
        this.getNoteListOfPDFMethod()
      })
    },
    updateNotesInfoOnChangeMethod(){
      let data = {
        pdf_paper:this.pdfIDForNote,
        title:this.updateNoteTitle,
        data:this.updateNoteData
      }
      this.$store.dispatch('updateNotesInfoOfPdfFun', {data:{data:data,id:this.updateNoteId}})
    },
    openUpdateNoteInfoScreenmethod(data){
      this.updateNoteId = data.id
      this.updateNoteTitle = data.title,
      this.updateNoteData = data.data
      this.pdfNotesInfoUpdateState = true
      this.pdfNotesListState = false
    },
  }
}